export default __webpack_public_path__ + "static/media/deer.be3b8c0d.gif";